import { Loader } from 'bda-web-ui-components';

export function BALoader() {
  return (
    <div>
      <Loader></Loader>
    </div>
  );
}
